export const getMedalThresholds = (communityBest) => {
    // Basic static thresholds
    const STATIC_BRONZE = 4;
    const STATIC_SILVER = 6;
    const STATIC_GOLD = 8;
    const STATIC_PLATINUM = 10;

    // Handle case where communityBest is 0 or undefined
    const cb = communityBest || 0;

    // Percentage based thresholds (rounded)
    const pctBronze = Math.max(1, Math.round(cb * 0.4));
    const pctSilver = Math.max(1, Math.round(cb * 0.6));
    const pctGold = Math.max(1, Math.round(cb * 0.8));
    const pctPlatinum = cb;

    return {
        bronze: Math.max(STATIC_BRONZE, pctBronze),
        silver: Math.max(STATIC_SILVER, pctSilver),
        gold: Math.max(STATIC_GOLD, pctGold),
        platinum: Math.max(STATIC_PLATINUM, pctPlatinum)
    };
};

export const getMedal = (length, communityBest) => {
    if (length === 0) return null;
    const thresholds = getMedalThresholds(communityBest);

    if (length >= thresholds.platinum) return 'platinum';
    if (length >= thresholds.gold) return 'gold';
    if (length >= thresholds.silver) return 'silver';
    if (length >= thresholds.bronze) return 'bronze';
    return null;
};

export const MEDAL_RANKS = {
    'bronze': 1,
    'silver': 2,
    'gold': 3,
    'platinum': 4
};

export const isBetterMedal = (newMedal, oldMedal) => {
    if (!newMedal) return false;
    if (!oldMedal) return true;
    return (MEDAL_RANKS[newMedal] || 0) > (MEDAL_RANKS[oldMedal] || 0);
};

